// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__InfoF","title":"ClientReferral_title__1in5Q","itemText":"ClientReferral_itemText__2J08m"};